import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import CourseService from "../../../Services/Course.service";
import CourseLookupModal from "./CourseLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => CourseService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data),
    label: "fullName",
    value: "id",
};
export const CourseSearch = makeSearch(makeSearchArgs);
export const CourseMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: CourseLookupModal }));
